/**
 * localStorage helpers that never throw.
 *
 * Private browsing and some embedded webviews reject storage access, and this
 * app is routinely opened inside an iframe during demos, so every read and
 * write is guarded.
 */

const KEY_PREFIX = 'crave:';

/** @param {string} key @param {string | null} [fallback] @returns {string | null} */
export function readString(key, fallback = null) {
  try {
    return window.localStorage.getItem(KEY_PREFIX + key) ?? fallback;
  } catch {
    return fallback;
  }
}

/** @param {string} key @param {string} value */
export function writeString(key, value) {
  try {
    window.localStorage.setItem(KEY_PREFIX + key, value);
  } catch {
    /* storage unavailable — values simply don't persist */
  }
}

/** @param {string} key @param {unknown} fallback @returns {any} */
export function readJson(key, fallback = null) {
  const raw = readString(key);
  if (raw == null) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

/** @param {string} key @param {unknown} value */
export function writeJson(key, value) {
  writeString(key, JSON.stringify(value));
}

/** @param {string} key */
export function remove(key) {
  try {
    window.localStorage.removeItem(KEY_PREFIX + key);
  } catch {
    /* no-op */
  }
}

/** Fully-qualified key, for code that needs to match raw `storage` events. */
export const storageKey = (key) => KEY_PREFIX + key;
